/*@flow*/
import styled from '@emotion/styled';

export default styled.div(
  props => `
  display: grid;
  grid-template-columns: ${props.columns || '1fr 30%'};
  min-height: 100px;
  height: 100%;
  grid-column-gap: 10px;
  padding-bottom: ${props.padBottom || 0};
`
);
